import { COLORS } from '@/constants/styles/colors';

export const flowerTypeFilter = 'flower_type';
export const occasionFilter = 'occasion';
export const colorFilter = 'color';

export const filterNames = {
  [flowerTypeFilter]: 'Flower Type',
  [occasionFilter]: 'Occasion',
  [colorFilter]: 'Color',
};

export const filterKeysArr = Object.keys(filterNames);

export type FilterNames = typeof filterNames;
export type FilterNamesKeys = keyof FilterNames;

export type SingleFilter = Set<string>;
export type FilterNamesState = Partial<Record<FilterNamesKeys, SingleFilter>>;

// Color Filter
export const colorFilterMap = {
  pink: COLORS.SWATCH_PINK,
  white: COLORS.WHITE,
  purple: COLORS.SWATCH_PURPLE,
  yellow: COLORS.SWATCH_YELLOW,
  red: COLORS.RED,
  orange: COLORS.SWATCH_ORANGE,
  green: COLORS.SWATCH_GREEN,
};

export const colorGradient = {
  assorted: [
    colorFilterMap.purple,
    colorFilterMap.red,
    colorFilterMap.pink,
    colorFilterMap.green,
    COLORS.SWATCH_BLUE,
    colorFilterMap.white,
    colorFilterMap.orange,
    colorFilterMap.yellow,
  ],
};
